import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import DropdownOption from 'components/Common/DropdownOption';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useRole } from 'components/Hooks/UserHooks';
import { AI_MODEL_BOOSTING_NEWS_WEATHER_OPTIONS, SYSTEM_CONFIG_KEY } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { getConfiguration, putConfiguration } from "../../../../store/thunks";

interface ModalConfigGenerateProps {
    isOpen: boolean;
    onClose: () => void;
}

const ModalConfigGenerate = ({ isOpen = false, onClose = () => { } }: ModalConfigGenerateProps) => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [condition, setCondition] = useState<{
        generate_header_prompt: string,
        generate_system_prompt: string,
    } | null>(null);

    const handleSave = async () => {
        try {
            if (isSaving) {
                return;
            }
            setIsSaving((_prev) => true);
            const _config = {
                configs: [
                    {
                        key: SYSTEM_CONFIG_KEY.GOVERNMENT_LOGO_BASED_NEWS_GENERATE_HEADER_PROMPT,
                        value: String(condition?.generate_header_prompt ?? ''),
                        is_active: 1,
                    },
                    {
                        key: SYSTEM_CONFIG_KEY.GOVERNMENT_LOGO_BASED_NEWS_GENERATE_SYSTEM_PROMPT,
                        value: String(condition?.generate_system_prompt ?? ''),
                        is_active: 1,
                    },
                ]
            };
            const response: any = await putConfiguration(_config);
            setIsSaving((_prev) => false);
            if (response?.code === 200) {
                toast(t("The process has been completed."), CONFIG_OPTION_TOAST_NORMAL);
                onClose?.();
            } else {
                toast(response?.message || response, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsSaving((_prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    }


    const handleGetConfig = async () => {
        try {
            const response: any = await getConfiguration();
            if (response?.code === 200) {
                const _configs = response?.data?.list || [];
                const data = {
                    generate_header_prompt: _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.GOVERNMENT_LOGO_BASED_NEWS_GENERATE_HEADER_PROMPT)?.value || '',
                    generate_system_prompt: _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.GOVERNMENT_LOGO_BASED_NEWS_GENERATE_SYSTEM_PROMPT)?.value || '',
                }
                setCondition((_prev: any) => ({ ..._prev, ...data }));
            }
        } catch (error: any) {
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    }

    useEffect(() => {
        if (isOpen) {
            handleGetConfig();
        }
    }, [isOpen]);

    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="lg"
                scrollable={false}
            >
                <ModalHeader toggle={() => onClose?.()}>
                    <>{t("Config Generate")}</>
                </ModalHeader>
                <ModalBody className="pt-2">
                    <Row>
                        {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_GOVERNMENT_NEWS, userPermissions) && (
                            <Col lg={12}>
                                <CardBody className="pt-3">
                                    <Row>
                                        <Col sm={12} className='mt-1 mb-2'>
                                            <LabelWrapper label={t('Header Prompt')} isShow={true} colorText="var(--vz-primary)">
                                                <Input
                                                    name="text"
                                                    type="textarea"
                                                    className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                                    placeholder=""
                                                    style={{ height: '200px' }}
                                                    value={condition?.generate_header_prompt}
                                                    onChange={(event: any) => {
                                                        const input = event.target.value;
                                                        setCondition((_prev: any) => ({ ..._prev, generate_header_prompt: input }))
                                                    }}
                                                    autoComplete="off"
                                                />
                                                <div className="w-100 mb-1 mb-xl-0 fs-12 text-muted pt-0">
                                                    {t(`{{keywords}} will replace dynamically`, { keywords: `{title}, {minister_code}, {data_contents}` })}
                                                </div>
                                            </LabelWrapper>
                                        </Col>
                                        <Col sm={12} className='mt-3 mb-2'>
                                            <LabelWrapper label={t('System Prompt')} isShow={true} colorText="var(--vz-primary)">
                                                <Input
                                                    name="text"
                                                    type="textarea"
                                                    className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                                    placeholder=""
                                                    style={{ height: '200px' }}
                                                    value={condition?.generate_system_prompt}
                                                    onChange={(event: any) => {
                                                        const input = event.target.value;
                                                        setCondition((_prev: any) => ({ ..._prev, generate_system_prompt: input }))
                                                    }}
                                                    autoComplete="off"
                                                />

                                            </LabelWrapper>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Col>
                        )}
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex justify-content-center align-item-center"></div>
                    <button
                        className="btn btn-primary"
                        type="button"
                        onClick={handleSave}
                        style={{ width: '120px' }}
                        disabled={isSaving}
                    >
                        {isSaving ? <Spinner size="sm" className="me-2" ></Spinner> : <></>}
                        {t("Button Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </React.Fragment >
    );
};

export default ModalConfigGenerate;